module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA4CAQAAAARWLNhAAAAoUlEQVR4Ae2YAQYFMQxEc5Q9QkmwR9ij5lgFFLA3yN/6qggf2vFZswNLySOJCSMi52GuTWOzmvl5fMvfGhjZ/SDMNXAyl94coJqMX9n8jbqrAALKVeqjCweo/a1UFCC/EjBHq5HVx70FMMtnBB7w/xZxTfFWgTc73gMCCEC6aVZ22sV78BuBB+BbxDUlgAB6Eb2IgLcC4IEUPFKDh4LwWPMDj/T1pXiDATQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_actualizar.png
// module id = iKSd
// module chunks = 8